import { motion } from "framer-motion";
import { TypingText } from "../useful/CustomText";

import styles from "../Home";
import { fadeIn, staggerContainer, zoomIn } from "../useful/motion";

const OurProject = () => (
  <section className={`${styles.paddings} relative z-7 mt-10`}>
    <div className="gradient-05 z-0" />
    <motion.div
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
      className={`${styles.innerWidth} mx-auto ${styles.flexCenter} flex-col`}
    >
      <TypingText title="PROJECT BACKGROUND" textStyles="text-center" />
      <div className="infos2">
        <motion.p
          variants={fadeIn("up", "tween", 0.2, 1)}
          className="mt-[10px] sm:text-[32px] text-[20px] singleinfo text-style"
          style={{ flex: "2" }}
        >
          <TypingText title="What is Cadmium ?" textStyles="question" />
          Cadmium, the <b>48</b>
          <sup>th</sup> element on the periodic table, stands as one of the most
          detrimental heavy metals to human health.
        </motion.p>
        <motion.p variants={zoomIn(0.2, 1)} className={`illustrationimage`}>
          <img
            src="https://static.igem.wiki/teams/4888/wiki/cdblack.png"
            alt="Cadmium"
          ></img>
        </motion.p>
      </div>
    </motion.div>
    <motion.div
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
      className={`${styles.innerWidth} mx-auto ${styles.flexCenter} flex-col`}
    >
      <div className="infos">
        <img
          src="https://static.igem.wiki/teams/4888/wiki/itemsv2gif.gif"
          alt="Items"
          className="illustrationvideo"
        ></img>
        <motion.p
          variants={fadeIn("up", "tween", 0.2, 1)}
          className="mt-[20px] sm:text-[32px] text-[20px] singleinfo text-style"
          style={{ flex: "2" }}
        >
          The dangerous nature of cadmium has led in the past decade to the
          introduction of measures restricting its use in Europe.
          Notwithstanding, its presence in the environments and in various
          products such as cigarette smoke, rechargeable batteries, pigments,
          coatings, plastics, and electronic parts remains. <br></br>
          Improper disposal of these items, along with the mining of metals
          where cadmium is a by-product and the utilization of fertilizers
          containing cadmium, has resulted in soil and water contamination.
          This, in turn, has impacted our food reserves, creating a concerning
          situation.
        </motion.p>
        <div className="gradient-04" style={{ zIndex: "-1" }} />
      </div>
    </motion.div>
    <motion.div
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: false, amount: 0.25 }}
      className={`${styles.innerWidth} mx-auto ${styles.flexCenter} flex-col`}
    >
      <div className="infos2">
        <motion.p
          variants={fadeIn("up", "tween", 0.2, 1)}
          className="mt-[60px] sm:text-[32px] text-[20px] text-style avoidover"
          style={{ flex: "2" }}
        >
          <TypingText
            title="What are its effects on human health ?"
            textStyles="question"
          />
          Cadmium toxically disrupts various organ systems, including the
          skeletal, urinary, reproductive, cardiovascular, central and
          peripheral nerves, as well as respiratory system.
        </motion.p>
      </div>
    </motion.div>
  </section>
);
export default OurProject;
